import requestProvider from "./axiosHandler";

const getAllWarehouseIncoming = () => {

    return requestProvider
        .get('/incoming/get-all')
}

const createWarehouseIncoming = (list) => {

    return requestProvider
        .post('/incoming', list)
}

const warehouseIncomingFilter = (list) => {
    return requestProvider
        .post('/incoming/search', list)
}

const warehouseIncomingMulti = (purchaseId, warehouseId) => {
    return requestProvider
        .post(`/incoming/purchase/${purchaseId}/${warehouseId}`)
}

const getIncomingsWithPage = (list) => {
    return requestProvider
        .post('/incoming/page-filter', list);
}

export {warehouseIncomingFilter, getAllWarehouseIncoming, createWarehouseIncoming, warehouseIncomingMulti, getIncomingsWithPage}